// import MDynamic from "./MDynamic.vue";
import MDynamic from "./MDynamic.vue";
export default MDynamic;
